<template>
    <div class="flex flex-col" v-if="team.isRender">
        <div class="flex items-center justify-between">
            <AtomsH1 v-if="shouldRender(team.groupName)">
                {{ team.groupName }}
            </AtomsH1>
            <MoleculesButtonAccordion
                :isContentOpen="isContentOpen"
                :handler="handleToggleContent"
            />
        </div>

        <ul
            :class="
                twMerge(
                    'mt-8 grid max-h-[1200px] grid-cols-1 gap-4 overflow-hidden duration-500 sm:grid-cols-3 lg:mt-14 lg:gap-6',
                    !isContentOpen && 'mt-0 max-h-0 opacity-0 lg:mt-0',
                )
            "
        >
            <li
                v-for="(m, idx) in team.members"
                :key="idx"
                class="flex overflow-hidden rounded-3xl border border-base-blueGrey bg-base-white shadow-custom sm:w-full sm:flex-col"
            >
                <div
                    class="relative h-full w-[120px] flex-shrink-0 overflow-hidden sm:h-0 sm:w-full sm:pt-[88.33%]"
                    v-if="team.hasImage && m.image"
                >
                    <img
                        :src="m.image.source_url"
                        :alt="m.image.alt_text"
                        class="absolute inset-0 h-full w-full rounded-3xl object-cover"
                        width="120"
                        height="106"
                    />
                </div>
                <div
                    class="flex w-full flex-col px-6 pb-[26px] pt-[22px] sm:pb-5 sm:pr-2 sm:pt-4 lg:px-8 lg:pb-6 lg:pr-5 lg:pt-5"
                >
                    <AtomsBody1
                        class="text-base-black-60"
                        v-if="shouldRender(m.title)"
                    >
                        {{ renderLines(m.title) }}
                    </AtomsBody1>
                    <AtomsH3
                        class="mt-1 text-base-black"
                        v-if="shouldRender(m.name)"
                    >
                        {{ renderLines(m.name) }}
                    </AtomsH3>
                </div>
            </li>
        </ul>
    </div>
</template>

<script setup>
import { twMerge } from "tailwind-merge";
import { renderLines, shouldRender } from "~/lib/utils";

const { team } = defineProps({
    team: {
        type: Object,
        required: true,
    },
});

const isContentOpen = ref(team.expand ? true : false);
const handleToggleContent = () => {
    isContentOpen.value = !isContentOpen.value;
};
</script>
